<script>
    import ButtonNormal from '@/components/buttons/ButtonNormal.vue';
    import AppDownloadModal from '../../shared/AppDownloadModal.vue';
    
    export default {
        name: 'WizardAdminThirdStep',
        props: {
            title: String,
            description: String,
            image: String,
            customData: Object,
        },
        components: {
            AppDownloadModal,
            ButtonNormal
        },
        data() {
            return {
                isModalVisible: false,
            };
        },
        methods: {
            getImage(name) {
                const images = require.context(
                    '../../../assets/wizard',
                    false,
                    /\.svg$/,
                );
                return images('./' + name + '.svg');
            },
        },
    };
</script>

<template>
    <div class="wizard-content-step">
        <div class="wizard-content-header">
            <div class="blocks">
                <div class="block grid-column-1">
                    <div class="description">
                        <h1>{{title}}</h1>
                        <p v-html="description"></p> <span>&nbsp;{{customData.phonenumber}}.</span>
                    </div>
                </div>
                <div class="block grid-column-2">
                    <div class="description text-center">
                        <h1>&nbsp;</h1>
                        <p v-html="customData.description2"></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="blocks">
            <div class="block grid-column-1">
                <div class="image">
                    <img :src="getImage(image)" atl="Wizard image" />
                </div>
            </div>
            <div class="block grid-column-2">
                <div class="info-text">
                    <a class="download-description" @click="isModalVisible = true">Jetzt herunterladen und
                            telefonieren.</a>
                </div>
            </div>
        </div>
        <div class="blocks">
            <div class="actions grid-column-1 right">
                <ButtonNormal @onClick="$router.push('/')" class="right" buttonTitle="Zum Dashboard" cssClass="btn btn-secondary"/>
            </div>
            <div class="actions grid-column-2">
                <ButtonNormal @onClick="$router.push('/wizard/first-user')" class="left" buttonTitle="Weiteren Benutzer hinzufügen" cssClass="btn btn-primary"/>
            </div>
        </div>
        <AppDownloadModal @close="isModalVisible = false" :isModalVisible="isModalVisible" :phoneNumber="customData.phonenumberforlogin"></AppDownloadModal>
    </div>
</template>

<style lang="scss" scoped>
    @import './step.scss';
    .description {
        p {
            display: inline;
        }
        &.text-center {
            text-align: center;
        }
    }
    
    .info-text {
        display: table;
        height: 100%;
        width: 100%;
        .download-description {
            padding-bottom: 32px;
            padding-left: 16px;
            font-weight: bold;
            color: $grey-dark;
        }
        a.download-description {
            cursor: pointer;
            position: relative;
            top: 110px;
            text-decoration: underline;
        }
    }
</style>
